import { Storage } from "aws-amplify";
import { useEffect, useState } from "react";

export const useGetImage = (value) => {
  const [imagePath, setImagePath] = useState(null);
  useEffect(() => {
    const getSignedUrl = async (value) => {
      if (!value) {
        return null;
      }
      try {
        const [identityId, key] = value.split("/");
        const url = key
          ? await Storage.get(key, { identityId, level: "protected" })
          : null;

        setImagePath(url);
      } catch {
        console.error("Could not provide an image url.");
      }
    };

    getSignedUrl(value);
  }, [value]);
  return imagePath;
};
